import { render, staticRenderFns } from "./SelectVehicleTableFields.vue?vue&type=template&id=4b95d195&"
import script from "./SelectVehicleTableFields.vue?vue&type=script&lang=js&"
export * from "./SelectVehicleTableFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports